import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconUrl"];
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Image } from 'foundations-components/transitional/components/Image';
import { specialtyColor } from 'foundations-theming-specialty/utils';
import styled from 'foundations-theming/utils';
import Chiclet from './AIChiclet';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_ICON_SIZE = 20;
const SCALE_FACTOR = 0.6;
const IconContainer = styled.div.withConfig({
  displayName: "ToolChiclet__IconContainer",
  componentId: "sc-9oyd3i-0"
})(["width:", "px;height:", "px;border-radius:", ";display:flex;align-items:center;justify-content:center;border:", ";"], ({
  size
}) => size, ({
  size
}) => size, ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => `${theme.borderWidth['100']} solid ${theme.color['border-tertiary-default']}`);
const ToolIcon = () => {
  return /*#__PURE__*/_jsx(IconCircle, {
    icon: BreezeSingleStarIcon,
    backgroundColor: specialtyColor('breeze-fill-secondary-hover'),
    color: specialtyColor('breeze-fill-primary-default'),
    display: "inline-flex",
    blockSize: `${DEFAULT_ICON_SIZE}px`,
    inlineSize: `${DEFAULT_ICON_SIZE}px`,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: "0",
    padding: "0"
  });
};
const IconUrlImage = ({
  iconUrl,
  size
}) => {
  const scaledSize = size * SCALE_FACTOR;
  return /*#__PURE__*/_jsx(IconContainer, {
    size: size,
    children: /*#__PURE__*/_jsx(Image, {
      src: iconUrl,
      height: scaledSize,
      width: scaledSize
    })
  });
};
const ToolChiclet = props => {
  const {
      iconUrl
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const Icon = iconUrl ? () => /*#__PURE__*/_jsx(IconUrlImage, {
    iconUrl: iconUrl,
    size: DEFAULT_ICON_SIZE
  }) : ToolIcon;
  return /*#__PURE__*/_jsx(Chiclet, Object.assign({}, rest, {
    icon: Icon
  }));
};
export default ToolChiclet;